import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  FormFieldSet,
  InfoCardNew,
  InfoCardNewAdv,
  InfoCardTwo,
  InfoWrapper,
  LogoLoader,
  Modal,
  SelectStatusTags,
  showToast,
  SmartTooltip,
  TableAdv,
} from "../../../../components";
import { mapTableRows } from "../../../../utils";
import AddJobPost from "./Modals/AddJobPost";
import JobPost from "./Modals/JobPost";
import { useDispatch, useSelector } from "react-redux";
import {
  getAccountDetailsStart,
  getJobCountStart,
  updateAccountStatus,
} from "../../../../redux/slices/accountDetails/accountDetailsSlice";
import { usePagination } from "../../../../hooks";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
// import {
//   fetchProspectByEmail,
//   updateStatusAPI,
// } from "../../../../redux/slices/accountDetails/accountDetailsApi";
import dayjs from "dayjs";
import { convertToUTC } from "../../../../utils/dateUtils";
import { fetchJobById } from "../../../../redux/slices/leads/leadsApi";
import { formatWords2 } from "../../../../utils/stringUtils";
import { getEndOfDay, getStartOfDay } from "../../../../utils/common";
import { useNavigate } from "react-router-dom";
import { fetchJobPost } from "../../../../redux/slices/bdmjobs/bdmjobsApi";
import { fetchProspectByEmail, updateStatusAPI } from "../../../../redux/slices/accountDetails/accountDetailsAPi";

const GetAccountDetails = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const [reason, setReason] = useState("");
  const [selectedTransferUser, setSelectedTransferUser] = useState("");
  const [statusModal, setStatusModal] = useState(false);
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {},
  );
  const { value } = useSelector((state) => state.totalCount);
  const [isJobPostModalOpen, setIsJobPostModalOpen] = useState(false);
  const [jobLoading, setJobLoading] = useState(false);
  const [isAddJobPostModalOpen, setIsAddJobPostModalOpen] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  // const [fromDate, setFromDate] = useState(dayjs());
  // const [toDate, setToDate] = useState(dayjs());
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [jobViewLoading, setJobViewLoading] = useState(false);
  const [datePickerKey, setDatePickerKey] = useState(0);

  const dispatch = useDispatch();
  const { jobs, counts, loading, error } = useSelector(
    (state) => state.accountDetails,
  );
  const { user } = useSelector((state) => state?.auth);
  const totalCount = value?.accDetials?.data || 0;
  const updateStatusOptions = [
    { label: "Positive", value: 2 },
    { label: "Closed", value: 11 },
    { label: "Transfer", value: 14 }, // value not confirmed
    // displaying closed status by default
  ];

  const transferModalOptions = [
    { value: 1, label: "Astha" },
    { value: 2, label: "Ershad" },
    { value: 3, label: "Chandan" },
    { value: 4, label: "Vijaya" },
    { value: 5, label: "Poojitha" },
    { value: 6, label: "Vamshi" },
    { value: 7, label: "Shiva" },
    { value: 8, label: "Pushpak" },
    { value: 9, label: "Raheem" },
    { value: 10, label: "Mahender" },
    { value: 11, label: "Vinay" },
    { value: 12, label: "Omkar" },
    { value: 13, label: "Rizwan" },
  ];
  const statusOptions = [
    { value: 1, label: "Active" },
    { value: 2, label: "Positive" },
    { value: 3, label: "Open" },
    { value: 4, label: "On Hold" },
    { value: 5, label: "Hold by Client" },
    { value: 6, label: "Interview L1" },
    { value: 7, label: "Interview L2" },
    { value: 8, label: "Interview L3" },
    { value: 9, label: "Priority" },
    { value: 10, label: "Filled" },
    { value: 11, label: "Closed" },
    { value: 12, label: "Agreement Sent" },
    { value: 13, label: "Agreement Accepted" },
  ];

  // const handleStatusChange = async (option, row) => {
  // if (option === 14) {
  // setSelectedRowData(row);
  // setStatusModal(true);
  // return;
  // }
  // };
  const handleStatusChange = async (option, row) => {
    if (option === 14) {
      setSelectedRowData(row);
      setStatusModal(true);
      return;
    }
    try {
      if (option === row.status) return;
      const payload = [
        {
          type: "SET",
          value: {
            status: option,
          },
        },
      ];
      const res = await updateStatusAPI({
        coll: "Job",
        uiid: row.uiid,
        payload,
      });
      if (res?.data) {
        const updatedJobs = [...jobs];
        const index = updatedJobs.findIndex((job) => job.uiid === row.uiid);

        if (index !== -1) {
          updatedJobs[index] = {
            ...updatedJobs[index],
            status: option,
          };
        }
        showToast("Status updated successfully", "success");
        dispatch(updateAccountStatus({ uiid: row.uiid, status: option }));
        const filters = buildFilters(user.data.uiid, fromDate, toDate);
        // dispatch(
        //   getJobCountStart({
        //     coll: "Job",
        //     // filters: {
        //     //   metrix: {
        //     //     type: "ACCOUNT_STATUS_METRICS",
        //     //     // value: ["positive", "open", "closed"],
        //     //     // value: ["positive", "open", "active", "hold", "interview"],
        //     //     value: [1,2,3,4,6,7,8,9,11],
        //     //     modifiedBy: user.data.uiid,
        //     //   },
        //     // },
        //     filters: {
        //       ...filters,
        //       metrix: {
        //         type: "ACCOUNT_STATUS_METRICS",
        //         // value: ["positive", "open", "closed"],
        //         // value: ["positive", "open", "active", "hold", "interview"],
        //         value: [1,2,3,4,6,7,8,9,11],
        //         modifiedBy: user.data.uiid,
        //       },
        //     },
        //     useAggregate: true,
        //   })
        // );
        dispatch(
          getJobCountStart({
            coll: "Job",
            filters: {
              ...filters,
              metrix: {
                type: "ACCOUNT_STATUS_METRICS",
                // value: ["positive", "open", "closed"],
                // value: ["positive", "open", "active", "hold", "interview"],
                value: [1, 2, 3, 4, 6, 7, 8, 9, 11],
                modifiedBy: user.data.uiid,
              },
            },
            useAggregate: true,
          }),
        );
      } else {
        showToast("Failed to update status", "error");
      }
    } catch (err) {
      console.error(err);
      showToast("Failed to update status", "error");
    }
  };

  const handleConfirmTransfer = async () => {
    if (!selectedTransferUser) {
      showToast("Please select a BDM to transfer", "error", 2000);
      return;
    }

    if (!reason.trim()) {
      showToast("Please provide a reason for transfer", "error", 2000);
      return;
    }

    const payload = [
      {
        type: "SET",
        value: {
          modifiedBy: selectedTransferUser?.value,
        },
      },
      {
        type: "PUSH",
        value: {
          transferHistory: {
            prevModifiedBy: selectedRowData.modifiedBy,
            currModifiedBy: selectedTransferUser?.value,
            modifiedOn: new Date().toISOString(),
            reason: reason.trim(),
          },
        },
      },
    ];

    try {
      const res = await updateStatusAPI({
        coll: "Job",
        uiid: selectedRowData.uiid,
        payload,
      });

      if (res?.data) {
        showToast("Transfer updated successfully", "success", 2000);
        setStatusModal(false);
        setSelectedTransferUser(null);
        setReason("");

        const filters = buildFilters(user.data.uiid, fromDate, toDate);
        dispatch(
          getAccountDetailsStart({
            coll: "Job",
            filters: filters,
            ref: "Company",
            lim: limit,
            pg: page,
            sort: { modifiedOn: -1 },
          }),
        );
        dispatch(
          getJobCountStart({
            coll: "Job",
            filters: {
              ...filters,
              metrix: {
                type: "ACCOUNT_STATUS_METRICS",
                value: [1, 2, 3, 4, 6, 7, 8, 9, 11],
                modifiedBy: user.data.uiid,
              },
            },
            useAggregate: true,
          }),
        );
      } else {
        showToast("Failed to update transfer", "error", 2000);
      }
    } catch (err) {
      console.error("Error updating transfer:", err);
      showToast("Error updating transfer", "error", 2000);
    }
  };

  const handleViewClick = async (jobID) => {
    try {
      setJobViewLoading(true);
      const response = await fetchJobPost({
        coll: "JobPosting",
        fil: { jobId: { type: "NONE", value: jobID } },
        ret: "uiid",
      });
      if (response?.data) {
        const jobpostUiid = response.data?.data?.uiid;
        sessionStorage.setItem("selectedJobUiid", jobpostUiid);
        sessionStorage.setItem(
          "prevJobsPage",
          window.location.pathname + window.location.search,
        );
        navigate("/ats/jobs/job-details", {
          state: { uiid: jobpostUiid },
        });
      } else {
        showToast("Job post not found", "error");
        console.log("Error Response:", response);
      }
    } catch (error) {
      console.error("Error fetching job post:", error);
    } finally {
      setJobViewLoading(false);
    }
  };

  // const columns = [
  //   {
  //     key: "id",
  //     label: "ID",
  //     width: 120,
  //   },
  //   {
  //     key: "companyName",
  //     label: "Company Name",

  //     render: (row) => <div className="text-info">{row.companyName}</div>,
  //   },
  //   { key: "jobTitle", label: "Job Title", width: 250 },
  //   { key: "jobTitle", label: "Job Location", width: 250 },
  //   {
  //     key: "jobDescription",
  //     label: "Job Description",

  //     className: "flex-1",
  //     render: (row) => (
  //       <div className="flex-1 flex items-center gap-2">
  //         <a
  //           href={row.jobDescription}
  //           target="_blank"
  //           className="text-info"
  //           rel="noreferrer"
  //         >
  //           Open Job Description
  //         </a>
  //       </div>
  //     ),
  //   },
  //   {
  //     key: "status",
  //     label: "Status",
  //     width: 170,
  //     render: (row) => (
  //       <div className="flex-1 flex items-center gap-2">
  //         <div className="w-fit truncate overflow-hidden whitespace-nowrap">
  //           <span className="text-success">{row.status}</span>
  //         </div>
  //       </div>
  //     ),
  //   },
  //   {
  //     key: "",
  //     label: "Actions",
  //     width: 100,
  //     render: (row) => (
  //       <div className="flex items-center justify-between gap-1">
  //         <Button
  //           type="icon"
  //           variant="text"
  //           icon="person_add"
  //           size="sm"
  //           color="black"
  //           onClick={() => {
  //             setIsJobPostModalOpen(true);
  //             setSelectedRowId(row.id);
  //           }}
  //         />
  //         <Button
  //           type="icon"
  //           variant="text"
  //           icon="docs_add_on"
  //           size="sm"
  //           color="black"
  //           onClick={() => {
  //             setIsAddJobPostModalOpen(true);
  //             setSelectedRowId(row.id);
  //           }}
  //         />
  //       </div>
  //     ),
  //   },
  // ];
  const buildFilters = (userId, fromDate, toDate, extraFilters = {}) => {
    let filters = { modifiedBy: { type: "NONE", value: userId } };

    // const start = fromDate
    //   ? dayjs(fromDate).startOf("day").toISOString()
    //   : dayjs().startOf("day").toISOString();

    // const end = toDate
    //   ? dayjs(toDate).endOf("day").toISOString()
    //   : dayjs().endOf("day").toISOString();
    const start = fromDate
      ? getStartOfDay(fromDate)
      : convertToUTC(dayjs().startOf("day").format("YYYY-MM-DD HH:mm"));

    const end = toDate
      ? getEndOfDay(toDate)
      : convertToUTC(dayjs().endOf("day").format("YYYY-MM-DD HH:mm"));

    filters = {
      ...filters,
      modifiedOn: {
        type: "DATE_RANGE",
        value: { from: start, to: end },
      },
      ...extraFilters,
    };

    return filters;
  };
  const columns = [
    {
      key: "serial",
      label: "ID",
      width: 120,
      render: (row) => row?.serial,
    },
    {
      key: "companyName",
      label: "Company Name",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <div className="text-info">{formatWords2(row?.companyId?.name)}</div>
      ),
    },
    {
      key: "jobTitle",
      label: "Job Title",
      width: "min-w-[250px]! max-w-[280px]!",
      render: (row) => <div>{formatWords2(row?.title)}</div>,
    },
    {
      key: "jobLocation",
      label: "Job Location",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) =>
        // row.location
        //   ? `${row.location.city || ""}, ${row.location.state || ""}, ${row.location.country || ""
        //   }`
        //   : "N/A",
        row?.location
          ? [row?.location?.city, row?.location?.state, row?.location?.country]
              .filter(Boolean)
              .join(", ")
          : "N/A",
    },
    {
      key: "jobDescription",
      label: "Job Description",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <div className="flex-1 flex items-center gap-2">
          <a
            // href={`https://www.linkedin.com/jobs/view/job-title-${row?.description}/`}
            href={
              row?.description?.startsWith("http")
                ? row.description
                : `https://${row.description}`
            }
            target="_blank"
            className="text-info"
            rel="noreferrer"
          >
            Open Job Description
          </a>
        </div>
      ),
    },
    // {
    //   key: "status",
    //   label: "Status",
    //   width: 170,
    //   render: (row) => (
    //     <div className="flex-1 flex items-center gap-2">
    //       <div className="w-fit truncate overflow-hidden whitespace-nowrap">
    //         <span className="text-success">{row.status}</span>
    //       </div>
    //     </div>
    //   ),
    // },
    {
      key: "status",
      label: "Status",
      width: "min-w-[180px]! max-w-[220px]!",
      render: (row) => {
        const currentStatus =
          statusOptions.find((opt) => opt.value === row.status) ||
          statusOptions.find((opt) => opt.value === 11); // default Closed

        return (
          <FormFieldSet
            type="select"
            noTitle
            placeholder="Select"
            size="xs-sm"
            value={currentStatus}
            options={updateStatusOptions}
            onChange={(option) => {
              handleStatusChange(option, row);
            }}
          />
          // <SelectStatusTags
          //   options={updateStatusOptions}
          //   value={currentStatus}
          //   onChange={(option) => {
          //     handleStatusChange(option.value, row);
          //   }}
          // />
        );
      },
    },

    {
      key: "",
      label: "Actions",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <div className="flex gap-5">
          <SmartTooltip description={"Job Post"} noicon>
            <Button
              type="icon"
              variant="text"
              icon="docs_add_on"
              size="sm"
              disabled={row?.status === 3 || row?.status === 11}
              color="black"
              onClick={() => {
                setIsAddJobPostModalOpen(true);
                setSelectedRowId(row?.serial);
                setSelectedRowData(row);
              }}
            />
          </SmartTooltip>
          <SmartTooltip description={"Add Other Job"} noicon>
            <Button
              type="icon"
              variant="text"
              icon="person_add"
              size="sm"
              color="black"
              // onClick={() => {
              //   setIsJobPostModalOpen(true);
              //   setSelectedRowId(row?.serial);
              //   setSelectedRowData(row);
              // }}
              onClick={() => handleOpenJobPostModal(row)}
            />
          </SmartTooltip>
          {row.status === 3 && (
            <SmartTooltip description={"View"} noicon>
              <Button
                type="icon"
                variant="text"
                icon="visibility"
                size="xs"
                color="black"
                onClick={() => handleViewClick(row?.uiid)}
              />
            </SmartTooltip>
          )}
        </div>
      ),
    },
  ];
  const status = ["Positive", "Closed", "Transfer"];
  const rows = Array.from({ length: 5 }, (_, i) => ({
    id: i + 100,
    companyName: `Company ${i + 1}`,
    jobTitle: `Job Title ${i + 1}`,
    jobLocation: `Job Location ${i + 1}`,
    jobDescription: `https://www.linkedin.com/jobs/view/job-title-${i + 1}/`,
    status: status[Math.floor(Math.random() * status.length)],
  }));

  // console.log("jobs",jobs)
  const filterModifiedOn = [...(jobs || [])].sort((a, b) => {
    return new Date(b.modifiedOn) - new Date(a.modifiedOn);
  });
  const filteredRows = filterModifiedOn.filter((row) => {
    if (!searchValue.trim()) return true;

    const lowerSearch = searchValue.trim().toLowerCase();

    const company = (row.companyId?.name || "").toLowerCase();
    const title = (row?.title || "").toLowerCase();
    // const location = (row.jobLocation || "").toLowerCase();
    const location = row?.location
      ? `${row?.location?.city || ""} ${row?.location?.state || ""} ${
          row?.location?.country || ""
        }`.toLowerCase()
      : "";
    const statusLabel =
      statusOptions
        .find((opt) => opt.value === row.status)
        ?.label.toLowerCase() || "";

    return (
      company.includes(lowerSearch) ||
      title.includes(lowerSearch) ||
      location.includes(lowerSearch) ||
      statusLabel.includes(lowerSearch)
    );
  });
  // const mappedRows = mapTableRows(rows, columns);
  const mappedRows = mapTableRows(
    // jobs?.map((job, idx) => ({ ...job, serial: idx + 1 })) || [],
    filteredRows?.map((job, idx) => ({ ...job, serial: idx + 1 })) || [],
    columns,
  );
  const handleGetJobDetails = async () => {
    if (isSubmitting) return;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      showToast("Please enter a valid email", "error", 2000);
      return;
    }
    try {
      setIsSubmitting(true);
      const response = await fetchProspectByEmail({
        coll: "Prospect",
        filters: {
          email: { type: "SEARCH", value: email?.trim()?.toLocaleLowerCase() },
        },
        addedBy: user.data.uiid,
      });
      const result = response?.data?.field?.[0]?.result;

      if (!result?.success) {
        console.log("result", result);
        showToast(result?.response || "Email not found", "error", 2000);
        return;
      }
      showToast(`Job status fetched successfully!`, "success", 2000);
      setFromDate(new Date());
      setToDate(new Date());
      setDatePickerKey(prev => prev + 1);
      // const filters = buildFilters(user?.data?.uiid, fromDate, toDate);
      // dispatch(
      //   totalCountStart({
      //     collection: "jobs",
      //     coll: "Job",
      //     tname: "accDetials",
      //     // filters: { modifiedBy: { type: "NONE", value: user.data.uiid } },
      //     filters: filters,
      //     app: "ats",
      //   }),
      // );
      // dispatch(
      //   getAccountDetailsStart({
      //     coll: "Job",
      //     filters: filters,
      //     // filters: { modifiedBy: { type: "NONE", value: user.data.uiid } },
      //     ref: "Company",
      //     lim: limit,
      //     pg: page,
      //     sort: { modifiedOn: -1 },
      //   }),
      // );
      // dispatch(
      //   getJobCountStart({
      //     coll: "Job",
      //     filters: {
      //       ...filters,
      //       metrix: {
      //         type: "ACCOUNT_STATUS_METRICS",
      //         // value: ["positive", "open", "closed"],
      //         // value: ["positive", "open", "active", "hold", "interview"],
      //         value: [1, 2, 3, 4, 6, 7, 8, 9, 11],
      //         modifiedBy: user?.data?.uiid,
      //       },
      //     },
      //     useAggregate: true,
      //   }),
      // );
    } catch (err) {
      console.error("Error fetching prospect by email", err);
    } finally {
      setEmail("");
      setIsSubmitting(false);
    }
  };
  const mapJobCounts = (data) => {
    if (!data || data.length === 0) return {};

    const counts = data;

    return {
      positive: counts["2"] || 0,
      open: counts["3"] || 0,
      closed: counts["11"] || 0,
      hold: counts["4"] || 0,
      interview: (counts["6"] || 0) + (counts["7"] || 0) + (counts["8"] || 0), // Interview L1+L2+L3
    };
  };

  const formatJobForModal = (job, company) => {
    if (!job || !company) return null;

    const contacts = (job?.prospectIds || []).map((p) => ({
      name: `${p?.firstName || ""} ${p?.lastName || ""}`.trim(),
      designation: p?.designation || "-",
      location: p?.location || "-",
      email: p?.email?.email || "-",
      phone: p?.mobile
        ? `${p?.mobile?.code || ""} ${p?.mobile?.number || ""}`
        : "-",
      uiid: p?.uiid,
    }));

    return {
      id: job?.uiid,
      jobId: job?.uiid,
      companyId: company?.uiid,
      companyName: company?.name || "-",
      website: company?.website || "",
      industry: company?.industry || "",
      jobTitle: job?.title || "",
      jobLocation: job?.location
        ? `${job?.location?.city || "-"}, ${job?.location?.state || "-"}, ${job?.location?.country || "-"}`
        : "-",
      jobDescription: job?.description || "",
      contactDetails: contacts,
      addedBy: job?.addedBy || null,
    };
  };

  const handleOpenJobPostModal = async (row) => {
    try {
      setIsJobPostModalOpen(true);
      setJobLoading(true);

      const job = await fetchJobById(row?.uiid);

      const company = row?.companyId;

      const formattedData = formatJobForModal(job, company);

      setSelectedRowData(formattedData);
    } catch (err) {
      console.error("Error opening JobPost modal:", err);
      showToast("Failed to load job details", "error");
    } finally {
      setJobLoading(false);
    }
  };

  // const handleServerSearch = (val) => {
  //   setSearchValue(val);

  //   dispatch(
  //     getAccountDetailsStart({
  //       coll: "Job",
  //       filters: {
  //         modifiedBy: { type: "NONE", value: user.data.uiid },
  //         // filter by companyName or jobTitle
  //         $or: [
  //           { "companyId.name": { type: "SEARCH", value: val } },
  //           { title: { type: "SEARCH", value: val } },
  //         ],
  //       },
  //       ref: "Company",
  //       lim: limit,
  //       pg: page,
  //     })
  //   );
  // };

  useEffect(() => {
    if (!fromDate || !toDate) return;
    const filters = buildFilters(user?.data?.uiid, fromDate, toDate);
    dispatch(
      totalCountStart({
        collection: "jobs",
        coll: "Job",
        tname: "accDetials",
        filters: filters,
        app: "ats",
      }),
    );
    dispatch(
      getAccountDetailsStart({
        coll: "Job",
        filters: filters,
        ref: "Company",
        lim: limit,
        pg: page,
        sort: { modifiedOn: -1 },
      }),
    );
    dispatch(
      getJobCountStart({
        coll: "Job",
        filters: {
          ...filters,
          metrix: {
            type: "ACCOUNT_STATUS_METRICS",
            value: [1, 2, 3, 4, 6, 7, 8, 9, 11],
            modifiedBy: user?.data?.uiid,
          },
        },
        useAggregate: true,
      }),
    );
  }, [dispatch, page, limit, fromDate, toDate]);
  const mappedCounts = mapJobCounts(counts);
  return (
    <div>
      <div className=" gap-10 my-5">
        <InfoWrapper>
          <InfoCardNewAdv
            title="Open Positive"
            value={mappedCounts?.positive}
            layout="option8"
            icon="work"
            isLoading={loading}
          />
          <InfoCardNewAdv
            title="Open Jobs"
            value={mappedCounts?.open}
            layout="option8"
            icon="work"
            isLoading={loading}
          />
          <InfoCardNewAdv
            title="Closed Jobs"
            value={mappedCounts?.closed}
            layout="option8"
            icon="work"
            isLoading={loading}
          />
          <InfoCardNewAdv
            title="Hold Jobs"
            value={mappedCounts?.hold}
            layout="option8"
            icon="work"
            isLoading={loading}
          />
          <InfoCardNewAdv
            title="Interview"
            value={mappedCounts?.interview}
            layout="option8"
            icon="work"
            isLoading={loading}
          />
        </InfoWrapper>
      </div>
      <div className="serchsection  flex justify-center">
        <div className="flex gap-10 shadow-md shadow-gray-300 p-1 overflow-hidden flex-1 max-w-[600px] border border-gray-200 rounded-full">
          <input
            className="w-full focus:outline-none ml-5"
            placeholder="Enter Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <div className="flex-1">
            <Button
              title="Get Job Details"
              icon={"search"}
              className="rounded-full w-full py-3"
              onClick={handleGetJobDetails}
              disabled={isSubmitting}
            />
          </div>
        </div>
      </div>
      <div>
        <TableAdv
          columns={columns}
          rows={mappedRows}
          serverPagination={true}
          totalCount={totalCount}
          page={page}
          limit={limit}
          onPaginationChange={setPage}
          tableId={"bdmam_getaccountdetails"}
          onLimitChange={handleLimitChange}
          serverSerchValue={searchValue}
          serverOnSearch={(key, val) => setSearchValue(val)}
          toolbarRight={{
            add: [
              {
                component: (
                  // <div className="flex items-center gap-2">
                  //   <FormFieldSet
                  //     noTitle
                  //     type="datepicker"
                  //     placeholder="From"
                  //     onChange={(value) => setFromDate(value)}
                  //     maxDate={toDate}
                  //     value={fromDate}
                  //     size="sm"
                  //   />
                  //   <FormFieldSet
                  //     noTitle
                  //     type="datepicker"
                  //     placeholder={"To"}
                  //     value={toDate}
                  //     onChange={(value) => setToDate(value)}
                  //     minDate={fromDate}
                  //     size="sm"
                  //   />
                  // </div>
                  //  <FormFieldSet
                  //   noTitle
                  //   placeholder="Select date range"
                  //   type="datepickerRange"
                  //   size="sm"
                  //   value={{
                  //     from: fromDate,
                  //     to: toDate,
                  //   }}
                  //   onChange={(range) => {
                  //     setFromDate(range?.from || null);
                  //     setToDate(range?.to || null);
                  //   }}
                  // />
                  <FormFieldSet
                    key={datePickerKey}
                    noTitle
                    placeholder="Select date range"
                    type="datepickerRange"
                    size="sm"
                    value={{
                      from: fromDate,
                      to: toDate,
                    }}
                    onChange={(range) => {
                      console.log("range", range);
                      setFromDate(range?.from || null);
                      setToDate(range?.to || null);
                    }}
                  />
                ),
              },
            ],
            search: true,
            filter: true,
            download: true,
          }}
        />
      </div>
      <Modal
        title={
          formatWords2(selectedRowId
            ? mappedRows.find((row) => row.serial === selectedRowId).companyId?.name
            : "Add Job Post")
        } // title slected row jobTitle
        isOpen={isAddJobPostModalOpen}
        onClose={() => {
          setIsAddJobPostModalOpen(false);
          setSelectedRowId(null);
        }}
        width="w-full"
        titleColor={"primary"}
      >
        <AddJobPost
          data={selectedRowData}
          onClose={() => {
            setIsAddJobPostModalOpen(false);
            setSelectedRowId(null);
          }}
          onSuccess={() => {
            setIsAddJobPostModalOpen(false);
            setSelectedRowId(null);
            const filters = buildFilters(user?.data?.uiid, fromDate, toDate);
            dispatch(
              getAccountDetailsStart({
                coll: "Job",
                // filters: { modifiedBy: { type: "NONE", value: user.data.uiid } },
                filters: filters,
                ref: "Company",
                lim: limit,
                pg: page,
                sort: { modifiedOn: -1 },
              }),
            );
            dispatch(
              getJobCountStart({
                coll: "Job",
                filters: {
                  ...filters,
                  metrix: {
                    type: "ACCOUNT_STATUS_METRICS",
                    // value: ["positive", "open", "closed"],
                    // value: ["positive", "open", "active", "hold", "interview"],
                    value: [1, 2, 3, 4, 6, 7, 8, 9, 11],
                    modifiedBy: user?.data?.uiid,
                  },
                },
                useAggregate: true,
              }),
            );
          }}
        />
      </Modal>
      <Modal
        title={
          formatWords2(selectedRowId
            ? mappedRows.find((row) => row.serial === selectedRowId).companyId?.name
            : "Add Job Post")
        } // title slected row jobTitle
        isOpen={isJobPostModalOpen}
        onClose={() => {
          setIsJobPostModalOpen(false);
          setSelectedRowId(null);
        }}
        width="w-full"
        titleColor={"primary"}
      >
        {/* <JobPost
          data={selectedRowData}
          onClose={() => {
            setIsJobPostModalOpen(false);
            setSelectedRowId(null);
          }}
        /> */}
        {jobLoading ? (
          <div className="py-10 text-center">Loading...</div>
        ) : (
          <JobPost
            data={selectedRowData}
            onClose={() => {
              setIsJobPostModalOpen(false);
              setSelectedRowData(null);
            }}
            onSuccess={() => {
              setIsJobPostModalOpen(false);
              setSelectedRowData(null);
              const filters = buildFilters(user?.data?.uiid, fromDate, toDate);
              dispatch(
                getAccountDetailsStart({
                  coll: "Job",
                  // filters: { modifiedBy: { type: "NONE", value: user.data.uiid } },
                  filters: filters,
                  ref: "Company",
                  lim: limit,
                  pg: page,
                  sort: { modifiedOn: -1 },
                }),
              );
            }}
          />
        )}
      </Modal>
      <Modal
        isOpen={statusModal}
        onClose={() => setStatusModal(false)}
        title={"Transfer"}
        width="max-w-3xl"
      >
        <div className="grid grid-cols-2 my-4">
          <FormFieldSet
            title={"Select BDM Transfer"}
            type="bdmUsers"
            placeholder="Select"
            // options={transferModalOptions}
            value={selectedTransferUser}
            showSearch
            onChange={(option) => setSelectedTransferUser(option)}
          />
        </div>
        <FormFieldSet
          title={"Reason For Transfer"}
          type="textArea"
          placeholder="Your description"
          rows={3}
          value={reason}
          onChange={(value) => setReason(value)}
        />
        <div className="flex justify-end items-center gap-2 my-4">
          <Button
            title={"Cancel"}
            variant="outlined"
            size="sm"
            onClick={() => setStatusModal(false)}
          />
          <Button title={"Confirm"} size="sm" onClick={handleConfirmTransfer} />
        </div>
      </Modal>
      <Backdrop isOpen={loading || jobViewLoading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default GetAccountDetails;
